import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>   
    <App/>
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('✅ PWA: App is ready for offline use');
  },
  onUpdate: (registration) => {
    console.log('🔄 PWA: New version available. Please refresh to update.');
    
    // Show update notification to user
    if (window.confirm('New version available! Refresh to update?')) {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }
  }
});

// Check for updates every hour
setInterval(() => {
  serviceWorkerRegistration.checkForUpdates();
}, 60 * 60 * 1000);
